import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ACLINFO, USERINFO} from '../../../gen/swagger-api';
import {UserType} from '../../shared/model/user-type';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DefaultService} from '../../../gen/swagger-api/api/default.service';
import {ErrorHandlingService} from '../../shared/services/error-handling-service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {AddNewUserPermissionComponent} from '../modals/add-new-user-permission/add-new-user-permission.component';
import {Subject} from 'rxjs';
import {AlertService} from '../../shared/services/alert.service';
import {DeleteQuestionModalComponent} from '../modals/delete-question-modal/delete-question-modal.component';
import {Observable} from 'rxjs/Observable';
import {USERACCESSCONTROL} from '../../shared/model/USERACCESSCONTROL';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {EndpointType} from '../../shared/model/endpoint-type';
import {environment} from '../../../environments/environment';
import {AmplifyService} from 'aws-amplify-angular';


function passwordMatch(c: AbstractControl) {
  const passwordControl = c.get('password');
  const confirmPasswordControl = c.get('confirmPassword');

  if (passwordControl.pristine || confirmPasswordControl.pristine) {
    return null;
  }
  if (passwordControl.value === confirmPasswordControl.value) {
    return null;
  }
  return {'match': true};
}


@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})


export class UserManagementComponent implements OnInit {
  static readonly LIMIT: number = 50;
  newUserFormGroup: FormGroup;
  users: Array<USERINFO> = [];
  checkedUserIDs = [];
  userDetails: USERINFO = null;
  userPermissions: Array<USERACCESSCONTROL> = [];
  umPermissions: Array<ACLINFO> = [];
  userType: UserType;
  tabView = 'tab1';
  offset = 0;
  sortString: string;
  searchText: string;
  searchString$: Subject<string> = new Subject<string>();
  showUpdate = false;
  showDelete = false;
  showAdd = false;
  editPermissions = false;
  checkBoxes = {};
  newCheckBoxesValues = {};
  private bsModalRef: BsModalRef;
  private currentUserPermissionChecked;
  private permissionsToGetUpdated = [];
  selectedUserPermissionIds = [];
  operationsDisabled: boolean = this.selectedUserPermissionIds.length === 0;
  checked = false;
  submitted = false;
  editMode = false;
  newMode = false;
  viewMode = false;
  changes = false;

  private endpointType: EndpointType;


  /**----------------------------------------------------------------------------
   * constructor
   *-----------------------------------------------------------------------------*/
  constructor(private defaultService: DefaultService,
              private errorHandlingService: ErrorHandlingService,
              private formBuilder: FormBuilder,
              private alertService: AlertService,
              private cd: ChangeDetectorRef,
              private modalService: BsModalService,
              private amplifyService: AmplifyService,
  ) {
    this.searchString$.debounceTime(500)
      .distinctUntilChanged()
      .do(searchText => this.searchText = searchText)
      .switchMap(searchText => {
        this.users = [];
        this.offset = 0;

        return this.defaultService.usersGet(this.offset, UserManagementComponent.LIMIT, searchText, this.sortString);
      })
      .subscribe(users => {
        this.users = this.users.concat(users);
      });
  }

  onTextBoxChangeListener(searchValue: string) {
    this.changes = true;
  }


  /**----------------------------------------------------------------------------
   * ngOnInit
   *-----------------------------------------------------------------------------*/
  ngOnInit() {
    this.getUsers(false);
    const username = sessionStorage.getItem('username');
    this.getManagementUserPermissions(username);
    for (let i = 0; i < this.userPermissions.length; i++) {
      this.checkBoxes['read-' + i] = this.umPermissions[i].read;
      this.checkBoxes['update-' + i] = this.umPermissions[i].update;
      this.checkBoxes['delete-' + i] = (this.umPermissions[i] as any).delete;
      this.checkBoxes['use-' + i] = this.umPermissions[i].use;
      this.checkBoxes['withGrantOption-' + i] = this.umPermissions[i].withGrantOption;
    }
    this.endpointType = EndpointType.SERVICEPROVIDER;
    console.log(this.endpointType);
  }


  /**----------------------------------------------------------------------------
   * ngAfterViewInit
   *-----------------------------------------------------------------------------*/
  ngAfterViewInit() {
    this.cd.detectChanges();
  }


  /**----------------------------------------------------------------------------
   * getUsers
   *-----------------------------------------------------------------------------*/
  getUsers(concat: boolean = true, limit: number = UserManagementComponent.LIMIT, offset = 0, searchText?: string, sortString?: string) {
    this.offset = offset;
    this.defaultService.usersGet(offset, limit, searchText, sortString).subscribe(
      listOfUsers => {
        if (concat) {
          this.users = this.users.concat(listOfUsers);
        } else {
          this.users = listOfUsers;
        }
      },
      (error) => {
      this.errorHandlingService.errorHandling(error);
    }
    );
  }


  /**----------------------------------------------------------------------------
   * refreshUsersList
   *-----------------------------------------------------------------------------*/
  refreshUsersList() {
    this.getUsers(false, UserManagementComponent.LIMIT, 0, this.searchText, this.sortString);
  }


  /**----------------------------------------------------------------------------
   * onScrollDown
   *-----------------------------------------------------------------------------*/
  public onScrollDown() {
    this.offset = this.offset + UserManagementComponent.LIMIT;
    this.getUsers(true, UserManagementComponent.LIMIT, this.offset, this.searchText, this.sortString);
  }


  /**----------------------------------------------------------------------------
   * onSorted
   *-----------------------------------------------------------------------------*/
  onSorted(event) {
    this.sortString = event.sortColumn;
    if (event.sortDirection === 'asc') {
      this.sortString = '+' + this.sortString;
    } else if (event.sortDirection === 'desc') {
      this.sortString = '-' + this.sortString;
    }
    this.getUsers(false, UserManagementComponent.LIMIT, this.offset, this.searchText, this.sortString);
  }


  /**----------------------------------------------------------------------------
   * getUserDetailInformation
   *-----------------------------------------------------------------------------*/
  getUserDetailInformation(user) {
    let username = sessionStorage.getItem('username');
    this.showUpdate = false;
    this.defaultService.usersUserIdPermissionsGet(username, 'USER_MANAGEMENT').subscribe(permissions => {
        for(let i=0; i<permissions.length; i++) {
          if (((permissions[i].objectId === user.userId || permissions[i].objectId === '*') && permissions[i].update === true)) {
            this.showUpdate = true;
          }
        }
      }
    );
    if (user.userId === username) {
      this.showUpdate = true;
    }
    this.editMode = false;
    this.newMode = false;
    this.viewMode = true;
    this.userDetails = user;
    this.editPermissions = false;
    this.newUserFormGroup = this.formBuilder.group({
      userId: ['', [Validators.required]],
      firstName: [''],
      lastName: [''],
      email: [''],
      phone: [''],
      passwordGroup: this.formBuilder.group({
        password: [''],
        confirmPassword: [''],
      }, {validator: passwordMatch}),
    });

    this.newUserFormGroup.patchValue(user);
    console.log(user);
    this.getUserPermissions(user);
  }


  /**----------------------------------------------------------------------------
   * onSubmit
   *-----------------------------------------------------------------------------*/
  onSubmit(newSubscriptionForm) {
    const userData = newSubscriptionForm.value;
    if (userData.userId === '' || userData.passwordGroup.password === '' || userData.passwordGroup.confirmPassword === '') {
      this.setToDirty();
    } else if (this.newUserFormGroup.valid) {
      const password = userData.passwordGroup.password;
      delete userData.passwordGroup;
      userData['password'] = password;
      this.defaultService.usersPut(userData).subscribe(response => {
          this.refreshUsersList();
          this.alertService.successModal('User created successfully!');
          this.newUserFormGroup = null;
          this.newMode = false;
        },
        (error) => {
          this.refreshUsersList();
          this.errorHandlingService.errorHandling(error);
        });
    }
  }


  /**----------------------------------------------------------------------------
   * changeDateFormat
   *-----------------------------------------------------------------------------*/
  public changeDateFormat(date: Date): string {
    if (date) {
      return date.toString()
        .split('.')[0]
        .replace('T', ' ');
    }
    return '';
  }


  /**----------------------------------------------------------------------------
   * deleteUsers
   *-----------------------------------------------------------------------------*/
  deleteUsers() {
    if (this.checkedUserIDs.length !== 0) {
      this.bsModalRef = this.modalService.show(DeleteQuestionModalComponent);
      this.bsModalRef.content.type = 'users';
      this.bsModalRef.content.action.take(1).subscribe((success) => {
        if (success) {
          const calls = [];
          this.checkedUserIDs.forEach((userID, index) => {
            calls.push(this.defaultService.usersUserIdDelete(userID));
          });

          Observable.forkJoin(calls).subscribe(
            item => {
              this.alertService.successModal('Successfully deleted user(s)!');
              this.refreshUsersList();
              this.checkedUserIDs = [];
              this.newUserFormGroup = null;
            },
            error => {
              {
                if (error) {
                  this.errorHandlingService.errorHandling(error);
                }
              }
            }
          );
        }
      });
    }
  }


  /**----------------------------------------------------------------------------
   * addToCheckboxList
   *-----------------------------------------------------------------------------*/
  public addToCheckboxList(index: number, privileg: string, permissionValue: boolean): string {
    const checkbox = privileg + '-' + index.toString();
    this.checkBoxes[checkbox] = 'OLD';

    return checkbox;
  }


  /**----------------------------------------------------------------------------
   * addNewUser
   *-----------------------------------------------------------------------------*/
  addNewUser() {
    this.viewMode = false;
    this.newMode = true;
    this.editMode = false;
    this.editPermissions = false;
    this.newUserFormGroup = this.formBuilder.group({
      userId: ['', [Validators.required]],
      firstName: [''],
      lastName: [''],
      email: [''],
      phone: [''],
      passwordGroup: this.formBuilder.group({
        password: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]],
      }, {validator: passwordMatch}),
    });
  }


  /**----------------------------------------------------------------------------
   * cancelNewUser
   *-----------------------------------------------------------------------------*/
  cancelNewUser() {

    if (this.viewMode === false && this.editMode === false && !this.userDetails) {
      this.newUserFormGroup = null;
      this.editMode = false;
      this.newMode = false;
      this.viewMode = false;
    } else {
      this.newUserFormGroup = this.formBuilder.group({
        userId: ['', [Validators.required]],
        firstName: [''],
        lastName: [''],
        email: [''],
        phone: [''],
        passwordGroup: this.formBuilder.group({
          password: ['', [Validators.required]],
          confirmPassword: ['', [Validators.required]],
        }, {validator: passwordMatch}),
      });

      this.getUserPermissions(this.userDetails);
      this.newUserFormGroup.patchValue(this.userDetails);
      this.editMode = false;
      this.newMode = false;
      this.changes = false;
      this.viewMode = true;
      this.editPermissions = false;
      this.newCheckBoxesValues = {};
    }
  }


  /**----------------------------------------------------------------------------
   * updateUser
   *-----------------------------------------------------------------------------*/
  updateUser() {
    let user;
    user = this.newUserFormGroup.value;
    user.password = user.passwordGroup.password;
    delete user.passwordGroup;

    this.defaultService.usersUserIdPost(user.userId, user).subscribe(response => {
      if (!this.permissionsToGetUpdated.length) {
        this.alertService.successModal('User updated successfully!');
      }
      this.refreshUsersList();
      this.getUserPermissions(user);
    });
  }


  /**----------------------------------------------------------------------------
   * checkAllUsers
   *-----------------------------------------------------------------------------*/
  checkAllUsers(ev) {
    this.users.forEach(user => {
      if (ev.target.checked) {
        this.checkedUserIDs.push(user.userId);
      } else {
        this.checkedUserIDs = [];
      }
    });
  }


  /**----------------------------------------------------------------------------
   * onSelectCheckAllChecbokx
   *-----------------------------------------------------------------------------*/
  onSelectCheckAllChecbokx($event) {
    const id = $event.target.value;
    if (this.checkedUserIDs.includes(id)) {
      const index = this.checkedUserIDs.findIndex(d => d === id); // find index in your array
      this.checkedUserIDs.splice(index, 1); // remove element from array
    } else {
      this.checkedUserIDs.push(id);
    }
  }


  /**----------------------------------------------------------------------------
   * getUserPermissions
   *-----------------------------------------------------------------------------*/
  getUserPermissions(user) {
    this.currentUserPermissionChecked = user;
    this.defaultService.usersUserIdPermissionsGet(user.userId).subscribe(permissions => {
        this.userPermissions = permissions.map(p => {
          const pp: USERACCESSCONTROL = p as USERACCESSCONTROL;
          if (pp.objectType.toString() === 'CARD_GROUP') {
            try {
              if (!['*', 'action', Number.NaN].includes(pp.objectId)) {
                this.defaultService.cardGroupsCardGroupIdGet(pp.objectId).subscribe(response => {
                  if (pp.objectId === '*' || pp.objectId === 'action') {
                    pp.name = '';
                  } else {
                    pp.name = response.groupName;
                    if (pp.name === '' || !response.groupName) {
                      pp.name = '(empty)';
                    }
                  }
                }, error => {
                  if (pp.objectId === '*' || pp.objectId === 'action') {
                    pp.name = '';
                  } else {
                    pp.name = 'Card group not found';
                  }
                });
              }
            } catch (e) {
            }

          } else if (pp.objectType.toString() === 'POOL') {
            try {

              if (!['*', 'action', Number.NaN].includes(pp.objectId)) {
                this.defaultService.poolsPoolIdGet(+pp.objectId).subscribe(response => {
                  if (pp.objectId === '*' || pp.objectId === 'action') {
                    pp.name = '';
                  } else {
                    pp.name = response.poolName;
                    if (pp.name === '' || !response.poolName) {
                      pp.name = '(empty)';
                    }
                  }
                }, error => {
                  if (pp.objectId === '*' || pp.objectId === 'action') {
                    pp.name = '';
                  } else {
                    pp.name = 'Pool not found';
                  }
                });
              }
            } catch (e) {
            }
          } else if (pp.objectType.toString() === 'USER_MANAGEMENT') {
            try {
              if (!['*', 'action', Number.NaN].includes(pp.objectId)) {

                this.defaultService.usersUserIdGet(pp.objectId).subscribe(response => {
                  if (pp.objectId === '*' || pp.objectType.toString() === 'action') {
                    pp.name = '';
                  } else {
                    if (!response.firstName && !response.lastName) {
                      pp.name = '';
                    }
                    else {
                      pp.name = response.firstName + ' ' + response.lastName;
                    }
                  }
                }, error => {
                  if (pp.objectId === '*' || pp.objectId === 'action') {
                    pp.name = '';
                  } else {
                    pp.name = 'User not found';
                  }
                });
              }
            } catch (e) {
            }
          }
          return pp;
        });
      }
    );
  }


  /**----------------------------------------------------------------------------
   * getManagementUserPermissions
   *-----------------------------------------------------------------------------*/
  getManagementUserPermissions(user) {
    this.defaultService.usersUserIdPermissionsGet(user, 'USER_MANAGEMENT').subscribe(permissions => {
        this.umPermissions = permissions;
        this.checkUserPermissionRights(this.umPermissions);
        for (let i=0; i<permissions.length; i++) {
          if (permissions[i].objectId === '*' && permissions[i].update === true) {
            this.showUpdate = true;
          }
        }
      }
    );
    this.defaultService.usersUserIdPermissionsGet(user, 'USER_CREATION').subscribe(permissions => {
        if (permissions && permissions.length) {
          this.showAdd = true;
        }
      }
    );
    this.showDelete = true;
  }


  /**----------------------------------------------------------------------------
   * checkUserPermissionRights
   *-----------------------------------------------------------------------------*/
  checkUserPermissionRights(permissions: Array<ACLINFO>) {
    for (let i=0; i<permissions.length; i++) {
      if (permissions[i].read &&
        permissions[i].update &&
        permissions[i].withGrantOption &&
        permissions[i].objectType === 'USER_MANAGEMENT' &&
        this.editMode) {
        this.editPermissions = true;
        return true;
      }
    }
    this.editPermissions = false;
    return false;
  }


  /**----------------------------------------------------------------------------
   * enableEditing
   *-----------------------------------------------------------------------------*/
  enableEditing() {
    this.editMode = !this.editMode;
    this.viewMode = true;
    this.newMode = false;
    if (!this.editMode) {
      this.newCheckBoxesValues = {};
      this.getUserDetailInformation(this.userDetails);
    }
    this.checkUserPermissionRights(this.umPermissions);
  }


  /**----------------------------------------------------------------------------
   * alertForPermissionUpdate
   *-----------------------------------------------------------------------------*/
  alertForPermissionUpdate(value, type, permission, id?) {
    const editedPermission: ACLINFO = permission;
    let permissionUnderEditing = false;
    switch (type) {
      case 'read':
        editedPermission.read = value.target.checked;
        break;
      case 'update':
        editedPermission.update = value.target.checked;
        break;
      case 'use':
        editedPermission.use = value.target.checked;
        break;
      case 'delete':
        (editedPermission as any).delete = value.target.checked;
        break;
      case 'withGrantOption':
        editedPermission.withGrantOption = value.target.checked;
        break;
    }

    if (this.newCheckBoxesValues[id] !== undefined) {
      delete this.newCheckBoxesValues[id];
    } else {
      this.newCheckBoxesValues[id] = value.target.checked;
    }
    this.cd.detectChanges();
    this.permissionsToGetUpdated.forEach((p: ACLINFO) => {
        if (editedPermission.objectId === p.objectId && editedPermission.objectType === p.objectType) {
          permissionUnderEditing = true;
        }
      }
    );
    if (permissionUnderEditing === false) {
      this.permissionsToGetUpdated.push(editedPermission);
    }
  }


  /**----------------------------------------------------------------------------
   * createNewUserPermission
   *-----------------------------------------------------------------------------*/
  createNewUserPermission() {
    const initialState = '';
    this.bsModalRef = this.modalService.show(AddNewUserPermissionComponent, {initialState});
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.userID = this.currentUserPermissionChecked.userId;
    this.bsModalRef.content.action.take(1).subscribe((success) => {

      if (success) {
        this.getUserPermissions(this.currentUserPermissionChecked);
      }
    });
  }


  /**----------------------------------------------------------------------------
   * updatePermissions
   *-----------------------------------------------------------------------------*/
  updatePermissions() {
    const calls = [];
    this.permissionsToGetUpdated.forEach((permission: ACLINFO) => {
      calls.push(this.defaultService.usersUserIdPermissionsPost(this.currentUserPermissionChecked.userId, permission));
    });

    Observable.forkJoin(calls).subscribe(
      item => {
        this.alertService.successModal('User updated sucessfully');
        this.permissionsToGetUpdated = [];
        this.permissionsToGetUpdated = [];
        this.refreshUsersList();
      },
      error => {
        this.permissionsToGetUpdated = [];
        this.refreshUsersList();
        if (error) {
          this.errorHandlingService.errorHandling(error);
        }
      }
    );
  }


  /**----------------------------------------------------------------------------
   * updateUserInfo
   *-----------------------------------------------------------------------------*/
  updateUserInfo() {
    const userData = this.newUserFormGroup.value;
    if (this.changes) {
      console.log('dirty');
      this.setToDirty();
    }

    if (this.changes && this.newUserFormGroup.valid) {
      this.updateUser();
      this.updatePermissions();
      this.editMode = false;
      this.editPermissions = false;
      this.changes = false;
      this.newCheckBoxesValues = {};

      if (sessionStorage.getItem('username') === userData.userId) {
        this.login();
      }
    } else if (!this.changes) {
      this.updatePermissions();
      this.editMode = false;
      this.editPermissions = false;
      this.newCheckBoxesValues = {};

      if (sessionStorage.getItem('username') === userData.userId) {
        this.login();
      }
    }

  }


  /**----------------------------------------------------------------------------
   * setToDirty
   *-----------------------------------------------------------------------------*/
  setToDirty() {
    this.newUserFormGroup.controls.userId.markAsDirty();
    this.newUserFormGroup.controls.firstName.markAsDirty();
    this.newUserFormGroup.controls.lastName.markAsDirty();
    this.newUserFormGroup.get('passwordGroup.password').markAsDirty();
    this.newUserFormGroup.get('passwordGroup.confirmPassword').markAsDirty();
  }


  /**----------------------------------------------------------------------------
   * setToDirty
   *-----------------------------------------------------------------------------*/
  public checkAllUserPermissions(ev) {
    this.userPermissions.forEach(x => {
      if (ev.target.checked) {
        this.selectedUserPermissionIds.push({'objectId': x.objectId.toString(), 'objectType': x.objectType.toString()});
        this.checked = true;
      } else {
        this.selectedUserPermissionIds = [];
        this.checked = false;
      }
    });
    this.operationsDisabled = this.selectedUserPermissionIds.length === 0;
  }


  /**----------------------------------------------------------------------------
   * getUserPermissionByObjectIdAndObjectType
   *-----------------------------------------------------------------------------*/
  public getUserPermissionByObjectIdAndObjectType(objectId, objectType) {
    let selectedUserPermission;
    this.userPermissions.forEach(up => {
      if (up !== null && up.objectId === objectId && up.objectType === objectType) {
        selectedUserPermission = up;
        return;
      }
    });
    return selectedUserPermission;
  }


  /**----------------------------------------------------------------------------
   * onToggleSelectedUserPermission
   *-----------------------------------------------------------------------------*/
  public onToggleSelectedUserPermission(objectId, objectType) {

    let permissionExists = false;
    this.selectedUserPermissionIds.forEach(p => {
      if (p.objectId.toString() === objectId.toString() && p.objectType.toString() === objectType.toString()) {
        permissionExists = true;
      }
    });

    if (permissionExists) {
      const index = this.selectedUserPermissionIds.findIndex(d => d.objectId === objectId && d.objectType === objectType);
      this.selectedUserPermissionIds.splice(index, 1);
    } else {

      this.selectedUserPermissionIds.push({'objectId': objectId, 'objectType': objectType});
    }
    this.operationsDisabled = this.selectedUserPermissionIds.length === 0;
  }


  /**----------------------------------------------------------------------------
   * deleteUserPermission
   *-----------------------------------------------------------------------------*/
  public deleteUserPermission() {
    if (this.selectedUserPermissionIds.length !== 0) {
      const initialState = {};
      this.bsModalRef = this.modalService.show(DeleteQuestionModalComponent, {initialState});
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.type = 'user_permissions';

      this.bsModalRef.content.action.take(1).subscribe((value) => {
        if (value === true) {
          const responses = [];
          const errors = [];

          this.selectedUserPermissionIds.forEach(permissionId => {
            responses.push(this.defaultService.usersUserIdPermissionsDelete(this.userDetails.userId, permissionId.objectType,
              permissionId.objectId)
              .pipe(catchError(error => of(errors.push(error)))));
          });

          forkJoin(responses).subscribe(item => {
            if (item.every(val => val === null)) {
              this.getUserPermissions(this.userDetails);
              this.checked = false;
              this.alertService.successModal('Successfully deleted permission(s)!');
            } else {
              this.alertService.errors(errors,
                [],
                'userPermission',
                false,
                'User: ' + this.userDetails.firstName.toUpperCase() + ' ' + this.userDetails.lastName.toUpperCase() +
                ' has no rights to delete the following object ids: ');
            }
            if (errors.length !== responses.length) {
              this.getUserPermissions(this.userDetails);
            }

            this.checked = false;
            this.selectedUserPermissionIds = [];
          });
        }
      });
    }
  }


  /**----------------------------------------------------------------------------
   * permissionIdIsSelected
   *-----------------------------------------------------------------------------*/
  permissionIdIsSelected(objectId, objectType) {
    let answer = false;
    this.selectedUserPermissionIds.forEach(item => {
      if (item.objectId.toString() === objectId.toString() && item.objectType.toString() === objectType.toString()) {
        answer = true;
      }
    });
    return answer;
  }


  /**----------------------------------------------------------------------------
   * permissionIdIsSelected
   *-----------------------------------------------------------------------------*/
  login() {
    let authMethod;
    if (this.endpointType === EndpointType.ENTERPRISE) {
      authMethod = environment.enterpriseAccountEndpointAuthMethod;
    } else {
      authMethod = environment.serviceProviderEndpointAuthMethod;
    }
    if (this.newUserFormGroup.value.password) {
      if (authMethod === 'jwt') {
          this.amplifyService.auth().signIn(sessionStorage.getItem('username'), this.newUserFormGroup.value.password)
            .then(user => {
              sessionStorage.setItem('token', user.signInUserSession.accessToken.jwtToken);
              sessionStorage.setItem('username', user.signInUserSession.idToken.payload.name);
            })
            .catch(err => {
              this.alertService.error('wrong credentials');
            });
        }
      else {
        sessionStorage.setItem('token', btoa(`${this.userDetails.userId}:${this.newUserFormGroup.value.password}`));
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/user-management/user-management.component.ts